// extracted by mini-css-extract-plugin
export default {"th":"MedicationPage_th__Sy6d2","control":"MedicationPage_control__KbspF","icon":"MedicationPage_icon__SsVD0"};